import React from 'react'
import { InsightContentSettingType } from 'components/insightContent/types'
import { CountTypeStrings } from 'enums/CountType'
import { getNumberFormatter } from 'components/widget/AuthorsWidgets/share/Table/utils'
import { MessageConst } from 'enums'

import SingleMeasure from '../SingleMeasure'
import Title from './Title'

const NameMeasureBy = ({
  detailSetting,
  countType,
  forceNotScale
}: {
  detailSetting: InsightContentSettingType
  countType: CountTypeStrings
  forceNotScale?: boolean
}) => {
  const { selectionName } = detailSetting

  return (
    <SingleMeasure
      detailSetting={detailSetting}
      countType={countType}
      forceNotScale={forceNotScale}
      customMentionDisplay={(mentions) => {
        if (mentions) {
          return getNumberFormatter().format(mentions)
        }
        if (mentions === 0) {
          return MessageConst.ONE_PLUS
        }
        return MessageConst.EM_DASH
      }}>
      <Title countType={countType} selectionName={selectionName} />
    </SingleMeasure>
  )
}

export default NameMeasureBy
